module.exports = __webpack_public_path__ + "static/media/challengeus.984cf5ec.png";